import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import MomentPropTypes from 'react-moment-proptypes';
import CardSectionHeading from '../CardSectionHeading';
import CardRowKeyVal from '../CardRowKeyVal';
import moment from 'moment-timezone';
import compact from 'lodash/compact';
import get from 'lodash/get';
import map from 'lodash/map';

const propTypes = {
  details: PropTypes.shape({
    address: PropTypes.shape({
      line1: PropTypes.string,
      line2: PropTypes.string,
      city: PropTypes.string,
      region: PropTypes.string,
      postal: PropTypes.string,
    }),
    coverage_start_date: MomentPropTypes.momentString,
    personal_property_amount: PropTypes.string,
    all_peril_deductible: PropTypes.string,
    liability_limit: PropTypes.string,
  }),
};

const defaultProps = {
  details: {},
};

class PolicyDetailsRentersNationwide extends PureComponent {

  fixedConditionalLabels = {
    personal_liability: 'Personal liability',
    money: 'Money',
    fire_department_service_charge: 'Fire department service charge amount',
    credit_card: 'Credit card',
    brand_new_belongings: 'Brand new belongings',
    silverware: 'Silverware',
    loss_assessment: 'Loss assessment',
    medical_payments: 'Medical payments',
    firearms: 'Firearms',
    loss_of_use: 'Loss of use',
    all_peril_deductible: 'Deductible',
  };

  get fixedConditionalNodes() {
    return compact(map(this.fixedConditionalLabels, (label, key) => {
      if (get(this.props.details, `${key}`)) {
        return (
          <CardRowKeyVal
            key={key}
            title={label}
            detail={this.props.details[key]}
          />
        );
      }
    }));
  }

  get coverageStartDate() {
    return moment(this.props.coverage_start_date, 'YYYY-MM-DD').format('MMM DD, YYYY');
  }

  get coverageEndDate() {
    return moment(this.props.coverage_end_date, 'YYYY-MM-DD').format('MMM DD, YYYY');
  }

  render() {
    const { details } = this.props;

    return (
      <div>
        <CardRowKeyVal
          title="Coverage period"
          detail={`From ${this.coverageStartDate} to ${this.coverageEndDate}`}
        />
        <CardSectionHeading>
          Location Details
        </CardSectionHeading>
        <CardRowKeyVal
          title="Address"
          detail={
            <div>
              <span>{details.address.line1}</span>
              <br/>
              {details.address.line2 && [<span key="line2">{details.address.line2}</span>, <br key="line2br" />]}
              <span>{details.address.city}, {details.address.region} {details.address.postal}</span>
            </div>
          }
        />
        <CardRowKeyVal
          title="Start date"
          detail={this.coverageStartDate}
        />
        <CardSectionHeading>
          Policy Selections
        </CardSectionHeading>
        <CardRowKeyVal
          title="Personal property"
          detail={details.personal_property_amount}
        />

        {this.fixedConditionalNodes}
      </div>
    );
  }
}

PolicyDetailsRentersNationwide.propTypes = propTypes;
PolicyDetailsRentersNationwide.defaultProps = defaultProps;

export default PolicyDetailsRentersNationwide;
